/**
 * @fileoverview 视频播放器
 * @author zhenn
 */

define(function(require, exports, module) {

    var Base = require('c-base');
    var native = require('c-up-native');

    var Video = Base.extend({
        defaults: {
            wrap: '#wrap',
            // - 分帧加载视频源： http://www.asiainnovations.com/tmp/echo-hereweare.mp4
            // - 非分帧加载视频源：
            //      - http://www.w3school.com.cn/example/html5/mov_bbb.mp4
            //      - http://v.cdn.pengpengla.com/daidai/v/u/2016/4/5/194a8fec-d9d7-42d7-8d90-7eb2d12be2ae.mp4
            source: 'http://www.w3school.com.cn/example/html5/mov_bbb.mp4'
        },

        initialize: function() {
            var self = this;
            self.insertVideoElement();

            self.bindEvent();
        },

        clearTimer() {
            this.timer && clearTimeout(this.timer);
        },
        // 初始化video对象，插入dom
        insertVideoElement: function() {
            var self = this;
            var source = self.get('source').replace('v.cdn.upliveapps.com', 'v-cdn.upliveapps.com');;
            var poster = self.get('coverUrl');
            var $wrap = self.$wrap = $(self.get('wrap'));
            var attrs = [];
            var config = {
                preload: "auto",
                src: source,
                "webkit-playsinline": !0,
                playsinline: !0,
                "x-webkit-airplay": !0,
                "x5-video-player-type": "h5",
                "x5-video-player-fullscreen": !0,
                width: 1,
                height: 1
            }

            for (var p in config) {
                attrs.push(p + "=" + config[p]);
            }

            var video = self.$video = $('<video ' + attrs.join(' ') + '><p>No Support Video</p></video>');

            $wrap.append(video);

            video[0].load();

            return self;
        },

        bindEvent: function() {
            var self = this;
            let $video = self.$video;
            let $wrap = self.$wrap;
            let system = native.getSystem();

            if (system == 'android') {
                let isStarted = 0;
                $video.on('loadedmetadata', function() {
                    if (isStarted) {
                        return;
                    }
                    isStarted = 1;
                    self.videoLoadedHandler();
                    self.emit('start', self.$video);
                });

                $video.on('loadeddata', function() {
                    if (isStarted) {
                        return;
                    }
                    isStarted = 1;
                    self.videoLoadedHandler();
                    self.emit('start', self.$video);
                });

                $video.on('canplaythrough', () => {
                    if (isStarted) {
                        return;
                    }
                    isStarted = 1;
                    self.videoLoadedHandler();
                    self.emit('start', self.$video);
                });
            } else {
                $video.on('canplaythrough', function() {
                    self.videoLoadedHandler();
                    self.emit('start', self.$video);
                });
            }

            $video
                .on('ended', function() {
                    self.emit('ended');
                })
                .on('pause', function() {
                    self.emit('pause');
                })
                // android wechat事件，监听全屏事件及退出全屏 
                .on('x5videoenterfullscreen', () => {
                    this.emit('androidWechatEnterFullScreen');
                })
                .on('x5videoexitfullscreen', () => {
                    this.emit('androidWechatExitFullScreen');
                });

            $.channel.on('videopause', ()=>{
                if (!$video[0].paused) { // 暂停播放
                    this.pause();    
                }
            });
        },

        videoLoadedHandler: function() {
            var self = this,
                $video = self.$video;
           
            this.play();
        },

        play() {
            this.$video[0].play();
        },

        pause() {
            this.$video[0].pause();
        },

        destroy() {
            let video = this.$video;
            let wrap = this.$wrap;
            video[0].pause();
            video.attr('src', '');
            video[0].load();
            wrap.empty();
            this.clearTimer();
        },

    });

    module.exports = Video;

});



// WEBPACK FOOTER //
// ./js/component/video/index.js